import { render } from "./FormOsImmediate.vue?vue&type=template&id=244bec24&scoped=true"
import script from "./FormOsImmediate.vue?vue&type=script&lang=js"
export * from "./FormOsImmediate.vue?vue&type=script&lang=js"

import "./FormOsImmediate.vue?vue&type=style&index=0&id=244bec24&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244bec24"]])

export default __exports__
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanels,QTabPanel,QForm,QSelect,QRadio,QInput,QFooter,QToolbar,QBtn,QPageContainer});
